import React from "react"
import Cabecalho from "../Cabecalho"
import { ExtratoPixFornecedorView } from "./components/ExtratoPixFornecedorView"

export function ExtratoPixFornecedor() {
    return (
        <>
            <Cabecalho pagina="Extrato Pix" />
            <ExtratoPixFornecedorView />
        </>
    )
}
